/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 201 created object
 * @export
 * @interface PostCharactersCharacterIdFittingsCreated
 */
export interface PostCharactersCharacterIdFittingsCreated {
    /**
     * fitting_id integer
     * @type {number}
     * @memberof PostCharactersCharacterIdFittingsCreated
     */
    fittingId: number;
}

/**
 * Check if a given object implements the PostCharactersCharacterIdFittingsCreated interface.
 */
export function instanceOfPostCharactersCharacterIdFittingsCreated(value: object): value is PostCharactersCharacterIdFittingsCreated {
    if (!('fittingId' in value) || value['fittingId'] === undefined) return false;
    return true;
}

export function PostCharactersCharacterIdFittingsCreatedFromJSON(json: any): PostCharactersCharacterIdFittingsCreated {
    return PostCharactersCharacterIdFittingsCreatedFromJSONTyped(json, false);
}

export function PostCharactersCharacterIdFittingsCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCharactersCharacterIdFittingsCreated {
    if (json == null) {
        return json;
    }
    return {
        
        'fittingId': json['fitting_id'],
    };
}

export function PostCharactersCharacterIdFittingsCreatedToJSON(json: any): PostCharactersCharacterIdFittingsCreated {
    return PostCharactersCharacterIdFittingsCreatedToJSONTyped(json, false);
}

export function PostCharactersCharacterIdFittingsCreatedToJSONTyped(value?: PostCharactersCharacterIdFittingsCreated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fitting_id': value['fittingId'],
    };
}

